import { Routes, Route, Outlet } from 'react-router-dom';
import { Checkin } from 'pages/Checkin';
import { PersonalInformation } from 'pages/Checkin/Steps/PersonalInformation';
import { ValidationToken } from 'pages/Checkin/Steps/ValidationToken';
import { VerifyDocumentCPF } from 'pages/Checkin/Steps/VerifyDocumentCPF';
import { Accompanying } from 'pages/Checkin/Steps/Accompanying';
import { AddressCheckin } from 'pages/Checkin/Steps/Address';
import { AdditionalInfo } from 'pages/Checkin/Steps/AdditionalInfo';
import { ArrivalAndDepartureTime } from 'pages/Checkin/Steps/ArrivalAndDepartureTime';
import { AddAccompanying } from 'pages/Checkin/Steps/AddAccompanying';
import { SelfieValidation } from 'pages/Checkin/Steps/SelfieValidation';
import { VerifyDocumentPassport } from 'pages/Checkin/Steps/VerifyDocumentPassport';
import { SuccessfulCheckout } from 'pages/Checkin/Steps/SuccessfulCheckout';
import { EditAccompanying } from 'pages/Checkin/Steps/EditAccompanying';

export const Routers = () => {

  return (
    <Routes>
      {/* <Route path="/" element={<AwaitingPage />} /> */}

      <Route path="/" element={<Checkin />}>
        <Route element={<Outlet />} />
        <Route index element={<ValidationToken />} />
        <Route path=":id" element={<ValidationToken />} />
        <Route path=":id/personal-info" element={<PersonalInformation />} />
        <Route path=":id/address" element={<AddressCheckin />} />
        <Route path=":id/verify-document" element={<VerifyDocumentCPF />} />
        <Route path=":id/verify-passport" element={<VerifyDocumentPassport />} />
        <Route path=":id/personal-info" element={<PersonalInformation />} />
        <Route path=":id/selfie-validation" element={<SelfieValidation />} />
        <Route path=":id/accompanying" element={<Accompanying />} />
        <Route path=":id/add-accompanying" element={<AddAccompanying />} />
        <Route path=":id/edit-accompanying/:id/" element={<EditAccompanying />} />
        <Route path=":id/arrival-and-departure" element={<ArrivalAndDepartureTime />} />
        <Route path=":id/additional-info" element={<AdditionalInfo />} />
        <Route path=":id/successful" element={<SuccessfulCheckout />} />
      </Route>
    </Routes>
  );
};